import { getInfo, login, logout } from '@/api/user';
import Layout from '@/layout';
import { constantRoutes, resetRouter } from '@/router';
import { getToken, removeToken, setToken } from '@/utils/auth';
import { Message } from 'element-ui';
import websocket from '@/utils/websocket'
import { checkLoginForm,checkLoginOut } from '@/utils/duerService';
import { fetchSeatAccountInfo } from '@/api/seat';
const _import = require('../../router/_import_' + process.env.NODE_ENV); //获取组件的方法

//过滤路由方法封装
function filterAsyncRouter(asyncRouterMap) {
  //遍历后台传来的路由字符串，转换为组件对象
  const accessedRouters = asyncRouterMap.filter((route) => {
    if (route.component) {
      if (route.component === 'Layout') {
        //Layout组件特殊处理
        route.component = Layout;
      } else {
        route.component = _import(route.component);
      }
    }
    if (route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children);
    }
    return true;
  });
  return accessedRouters;
}

const state = {
  token: getToken(),

  enterpriseName: '', //系统名
  enterpriseType: '', //系统类型
  enterpriseId:0,//单位索引
  logo: '', //系统logo
  nickname: '', //用户名
  portrait: '', //用户头像
  roleName: '', //角色类型名
  id:0,//账号索引

  permission_routes: [],
  addRoutes: [],
};

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_enterpriseName: (state, enterpriseName) => {
    state.enterpriseName = enterpriseName;
  },
  SET_enterpriseType: (state, enterpriseType) => {
    state.enterpriseType = enterpriseType;
  },
  SET_enterpriseId: (state, enterpriseId) => {
    state.enterpriseId = enterpriseId;
  },
  SET_logo: (state, logo) => {
    state.logo = logo;
  },
  SET_nickname: (state, nickname) => {
    state.nickname = nickname;
  },
  SET_portrait: (state, portrait) => {
    state.portrait = portrait;
  },
  SET_id: (state, id) => {
    state.id = id;
  },
  SET_roleName: (state, roleName) => {
    state.roleName = roleName;
  },

  SET_permission_routes: (state, permission_routes) => {
    state.addRoutes = permission_routes;
    state.permission_routes = constantRoutes.concat(permission_routes);
  },
  SET_permission_routes_null: (state) => {
    state.permission_routes = [];
  },
};

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password } = userInfo;
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password })
        .then((response) => {
          if (response.token) {
            const { token } = response;
            //console.log('登陆成功！');
            commit('SET_TOKEN', token);
            setToken(token);
            resolve();
          } else {
            // console.log(response.errorMsg);
            const { errorMsg } = response;
            Message.error(errorMsg);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo()
        .then((response) => {
          // console.log('获取用户信息');
          const data = response.result[0];
          //用户信息和路由
          const {
            enterpriseName,
            enterpriseType,
            enterpriseId,
            logo,
            nickname,
            portrait,
            id,
            roleName,
          } = data;
          // let requstPaths = data.requstPaths;
          let { requstPaths } = data;

          if (!data) {
            reject('验证失败，请重新登录。');
          }
          commit('SET_enterpriseName', enterpriseName);
          commit('SET_enterpriseType', enterpriseType);
          commit('SET_enterpriseId', enterpriseId);
          commit('SET_logo', logo);
          commit('SET_nickname', nickname);
          commit('SET_portrait', portrait);
          commit('SET_id', id);
          commit('SET_roleName', roleName);
          requstPaths = filterAsyncRouter(requstPaths).concat([
            { path: '*', redirect: '/404', hidden: true },
          ]);
          commit('SET_permission_routes', requstPaths);
          resolve(data);
          websocket.Init(nickname);
          if(roleName === '坐席' || roleName === '全国坐席'){
            fetchSeatAccountInfo({account:nickname}).then((response)=>{
              if(response.result !== null){
                checkLoginForm(response.result.seatAccount,response.result.seatCallToken);
              }
            })
          }
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },

  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      // logout(state.token)
      logout()
        .then(() => {
          commit('SET_TOKEN', '');
          commit('SET_permission_routes_null');
          removeToken();
          resetRouter();
          // reset visited views and cached views
          // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
          dispatch('tagsView/delAllViews', null, { root: true });
          resolve();
          if(state.roleName==='坐席' || state.roleName === '全国坐席'){
            checkLoginOut();
          }
          websocket.Close();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      commit('SET_TOKEN', '');
      commit('SET_permission_routes_null');
      removeToken();
      resolve();
    });
  },

  // dynamically modify permissions
  async changeRoles({ commit, dispatch }, token) {
    commit('SET_TOKEN', token);
    setToken(token);

    // const { roles } = await dispatch('getInfo');
    const { paths } = await dispatch('getInfo');

    resetRouter();

    // generate accessible routes map based on roles
    const accessRoutes = await dispatch('permission/generateRoutes', paths, {
      root: true,
    });
    // dynamically add accessible routes
    router.addRoutes(accessRoutes);

    // reset visited views and cached views
    dispatch('tagsView/delAllViews', null, { root: true });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
